import {combineLatest} from 'rxjs';
import {filter, map, startWith} from 'rxjs/operators';
import {times} from '@/helper/num';
import {currenciesCurrencyCache$, ptConfig$} from '@/config';
import {fiat$} from '@/state/fiat';
import {indexPricesCache$} from '@/price-index/price-index';
import {contractAccounts$} from '@/contract-accounts/contract-accounts';
import {calcTotalAssets} from '@/assets/calc';
import type {AssetEntity, Assets, ContractAccount} from '@/types';

export const contractAssets$ = combineLatest([contractAccounts$, ptConfig$]).pipe(
  map(([contractAccounts, ptConfig]) => contractAccounts.map((account) => convertContractAssets(account, ptConfig))),
  startWith([])
);

export const contractTotalAssets$ = combineLatest([
  contractAssets$,
  indexPricesCache$,
  currenciesCurrencyCache$,
  fiat$,
]).pipe(
  map(([contractAssets, indexPricesCache, currencies, fiat]) =>
    calcTotalAssets(contractAssets, indexPricesCache, currencies, fiat, false, true)
  ),
  filter<Assets>(Boolean)
);

function convertContractAssets(account: ContractAccount, ptConfig = null) {
  // TODO: 由于新合约USDT账号ws数据过来是无放大的真实值，为了兼容现有系统，此处对新合约做放大处理
  let valueFactor = ['USDT', 'USDC', 'MUSDT'].indexOf(account.currency) > -1 ? 1e8 : 1;
  if (ptConfig && account.currency === ptConfig.symbol) {
    valueFactor = ptConfig.valueFactor;
  }
  return <AssetEntity>{
    currency: account.currency,
    valueEv: times(account.equityEv, valueFactor),
    bonusBalanceEv: times(account.bonusBalanceEv, valueFactor),
  };
}
